import { PublicCourse, PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent, useMemo } from 'react';
import styles from './styles.module.scss';
import { useEmbedExternalLinkProps } from '../../../../hooks/useEmbedExternalLinkProps';
import { useMinisiteLink } from '../../../../hooks/useMinisiteLink';
import ButtonLink from '../../../ButtonLink';

export type SecondaryButtonsProps = {
    course: PublicCourse;
    educator: PublicEducator;
    isEmbed: boolean;
};

export const SecondaryButtons: FunctionComponent<SecondaryButtonsProps> = ({
    course,
    educator,
    isEmbed,
}) => {
    const { target, rel } = useEmbedExternalLinkProps(isEmbed);
    const minisiteUrl = useMinisiteLink(educator.slug, '/enquiry');

    const contactUsUrl = useMemo(() => {
        const baseParams = new URLSearchParams({
            type: 'message',
            educator_slug: educator.slug,
            educator_name: educator.name,
            course_ref: course.slug,
            course_name: course.name,
        });

        if (isEmbed) {
            return `${minisiteUrl}?${baseParams.toString()}`;
        }
        return `/enquiry?${baseParams.toString()}`;
    }, [course, educator, isEmbed, minisiteUrl]);

    return (
        <ButtonLink
            href={contactUsUrl}
            rel={rel}
            target={target}
            className={styles.contactAndMoreBtn}
        >
            Contact Us
        </ButtonLink>
    );
};
